import { Attributes, EnumHelper } from "@singularsystems/neo-core";

export enum TradeOrderStatus {
    Pending = 1,
    Released = 2,
    Rejected = 3,    
    Confirmed = 4
}

// Use the enum helper to change the enum item display and description values, or the order of each item.
EnumHelper.decorateEnum(TradeOrderStatus, e => {
    e.describe(TradeOrderStatus.Pending, "Pending", "This is the description for Pending status");
    e.describe(TradeOrderStatus.Released, "Released", "This is the description for Released status");
    e.describe(TradeOrderStatus.Rejected, "Rejected", "This is the description for Rejected status");
    e.describe(TradeOrderStatus.Confirmed, "Confirmed", "This is the description for Confirmed status");
});

// Helper function to get status name from ID
export function getTradeOrderStatusName(statusId: number | null | undefined): string {
    if (!statusId) return "";
    
    switch (statusId) {
        case TradeOrderStatus.Pending:
            return "Pending";
        case TradeOrderStatus.Released:
            return "Released";
        case TradeOrderStatus.Rejected:
            return "Rejected";
        case TradeOrderStatus.Confirmed:
            return "Confirmed";
        default:
            return "";
    }
}